import { useCallback, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Alert,
  Button,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { BpmnEditor } from '../features/bpmn';
import { useCryptoKeyStore } from '../features/encryption';

export function BpmnEditorPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { activeKey, gkdkSlots, loadGKDKSlots } = useCryptoKeyStore();

  // Load GKDK slots on mount to get authority ID
  useEffect(() => {
    if (activeKey && gkdkSlots.length === 0) {
      loadGKDKSlots();
    }
  }, [activeKey, gkdkSlots.length, loadGKDKSlots]);

  // Get the authority ID from GKDK slots
  const authorityId = gkdkSlots.length > 0 ? gkdkSlots[0].authorityId : undefined;
  const keyFromUrl = searchParams.get('key') || '';
  const isOwnProcess = searchParams.get('own') === 'true';

  const handleBack = useCallback(() => {
    navigate('/processes');
  }, [navigate]);

  // Redirect if no process key provided
  if (!keyFromUrl) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Kein Prozess ausgewählt. Bitte wählen Sie einen Prozess aus der Liste.
        </Alert>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
        >
          Zur Prozessliste
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          size="small"
        >
          Zurück
        </Button>
        <Typography variant="h5">BPMN Editor</Typography>
        <Typography variant="body2" color="text.secondary">
          {keyFromUrl}
        </Typography>
      </Box>

      <Box sx={{ flex: 1 }}>
        <BpmnEditor
          key={keyFromUrl}
          processDefinitionKey={keyFromUrl}
          keyId={authorityId}
          isOwnProcess={isOwnProcess}
          height="100%"
        />
      </Box>
    </Box>
  );
}
